import React, { useEffect, useState } from 'react';
import apis from '@/pages/system/apis';
import { Divider, message } from 'antd';
import { SoundOutlined } from '@ant-design/icons';
import './index.less';
import ComponentLog from '@/components/component-log';

const Notify = () => {
  const [data, setData] = useState({
    items: [],
    totalCount: 0,
  });

  useEffect(() => {
    const conditions = {
      currentPage: 1,
      pageSize: 10,
      orderBySort: 'CREATED',
      sortAsc: false,
      online: 1,
    };
    apis
      .dripGenericActcenterBizNotifyList(conditions)
      .then((res) => {
        const { ret } = res;
        if (ret === '0') {
          setData(res.data);
        } else {
          message.error(res.msg);
        }
      })
      .catch((ex) => {
        message.error('数据请求失败');
      });
  }, []);

  if (data.items.length <= 0) return null;

  return (
    <div className="global-notify">
      <div className="title">
        <SoundOutlined />
        &nbsp;重要通知
        <Divider type="vertical"></Divider>
      </div>
      <ComponentLog clstag="yx_importantnotice_1665543707562|1">
        {data.items.slice(0, 3).map((item: any, index: number) => {
          return (
            <div key={item.ID} className="notify-item" onClick={() => item.jumpUrl && window.open(item.jumpUrl)}>
              <span className="num">{index + 1}</span>
              {item.title}
            </div>
          );
        })}
      </ComponentLog>
    </div>
  );
};

export default Notify;
